import { render, staticRenderFns } from "./taskDeliverDetail.vue?vue&type=template&id=90073282&scoped=true"
import script from "./taskDeliverDetail.vue?vue&type=script&lang=js"
export * from "./taskDeliverDetail.vue?vue&type=script&lang=js"
import style0 from "./taskDeliverDetail.vue?vue&type=style&index=0&id=90073282&prod&scoped=true&lang=css"
import style1 from "./taskDeliverDetail.vue?vue&type=style&index=1&id=90073282&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90073282",
  null
  
)

export default component.exports